// @flow

import React, { type Node } from 'react';
import { GlobalStyle } from './global-style';
import { Logo } from './logo';
import { LostInSpaceScene } from './lost-in-space-scene';
import { Content, Footer, Main, Message, Title, Wrapper } from './layout';
import { useEventBusPublisher } from '@tectonics/public-event-bus';
import { useTranslation } from 'react-i18next';
import englishVolcanes from '@tectonics/translate/locales/en/volcanes.json';

type Props = {
  error: Error,
  localTenancy?: string,
};

export function FatalErrorPage({ error }: Props): Node {
  useEventBusPublisher('fatalError:dispatch', error);

  const { t } = useTranslation('volcanes', { useSuspense: false });

  const title = t('fatalErrorTitle', { defaultValue: englishVolcanes.fatalErrorTitle });
  const message = t('fatalErrorMessage', { defaultValue: englishVolcanes.fatalErrorMessage });
  const footer = t('fatalErrorFooter', { defaultValue: englishVolcanes.fatalErrorFooter });

  return (
    <>
      <GlobalStyle />
      <Wrapper>
        <Main>
          <LostInSpaceScene />
          <Content>
            <Title>{title}</Title>
            <Message>{message}</Message>
          </Content>
        </Main>
        <Footer>
          {footer} <Logo/>
        </Footer>
      </Wrapper>
    </>
  );
}
